import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setOrderDetails } from '../../actions/orders';

const inputStyle = {
  padding: '8px',
  borderRadius: '4px',
  borderColor: 'hsl(0,0%,80%)',
  boxSizing: 'border-box',
  width: '100%',
  borderWidth: '1px',
  marginTop: '10px'
};

class Index extends Component {
  onQuantityChange(event) {
    const value = event.target.value
    this.props.setOrderDetails({ quantity: value });
  }

  render() {
    const { quantity, label, style: { body } } = this.props;

    return (
      <div className='text-left'>
        <span className='titles' style={{...body}}>{ label }</span>
        <input
          name="Quantity"
          className="form-control"
          type="number"
          min={1}
          style={{...body, ...inputStyle}}
          onChange={this.onQuantityChange.bind(this)}
          value={quantity}
        />
      </div>
    );
  }
}

export default connect(
  ({ order, settings }) => ({
    quantity: order.quantity,
    style: settings.style
  }),
  dispatch => ({
    setOrderDetails: (value) => dispatch(setOrderDetails(value)),
  }),
)(Index);
